// extracted by mini-css-extract-plugin
export default {"container":"container--hvb94","micro":"micro--EKD6U"};